if (!customElements.get('plumpy-newcomer-slideshow')) {
  customElements.define('plumpy-newcomer-slideshow', class extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-plumpy-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-plumpy-dot]'));
      this.index = Math.max(0, this.slides.findIndex((slide) => !slide.hidden));
      this.querySelector('[data-plumpy-prev]')?.addEventListener('click', () => this.go(this.index - 1));
      this.querySelector('[data-plumpy-next]')?.addEventListener('click', () => this.go(this.index + 1));
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.plumpyDot))));
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
      this.addEventListener('shopify:block:select', (event) => {
        const selected = this.slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
        if (selected >= 0) this.go(selected, false);
      });
      this.start();
    }
    disconnectedCallback() { this.stop(); }
    go(next, restart = true) {
      if (this.slides.length < 2) return;
      this.index = (next + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, index) => { const active = index === this.index; slide.hidden = !active; slide.classList.toggle('is-active', active); });
      this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.index)));
      if (restart) { this.stop(); this.start(); }
    }
    start() {
      if (this.dataset.autoplay !== 'true' || this.slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.stop();
      this.timer = window.setInterval(() => this.go(this.index + 1, false), Number(this.dataset.speed) || 5000);
    }
    stop() { if (this.timer) window.clearInterval(this.timer); this.timer = null; }
  });
}
